import React from 'react';
import { Link } from 'react-router-dom';
import Spacing from '../Spacing';
import { pageTitle } from '../../helpers/PageTitle';

export default function PaymentSuccess() {
  pageTitle('Payment Success');

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <div className="container">
        <div className="text-center">
          <div className="cs_success_icon mb-4">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="40" cy="40" r="40" fill="#0b5e4b"/>
              <path d="M25 40L35 50L55 30" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h1 className="cs_fs_50 cs_semibold mb-3">Payment Successful!</h1>
          <p className="cs_fs_18 mb-4">
            Thank you for your order. Your payment has been processed successfully.
          </p>
          <div className="cs_success_details cs_gray_bg_2 cs_radius_15 p-4 mb-4 d-inline-block">
            <h3 className="cs_fs_24 cs_semibold mb-2">Order Details</h3>
            <p className="mb-1"><strong>Product:</strong> Ayumedix Wellness Capsule</p>
            <p className="mb-1"><strong>Status:</strong> <span className="cs_accent_color">Confirmed</span></p>
            <p className="mb-0"><strong>Delivery:</strong> 3-5 business days</p>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
            <Link to="/" className="cs_btn cs_style_1 cs_fs_16 cs_rounded_5 cs_pl_30 cs_pr_30 cs_pt_15 cs_pb_15">
              Continue Shopping
            </Link>
            <Link to="/profile" className="cs_btn cs_style_2 cs_fs_16 cs_rounded_5 cs_pl_30 cs_pr_30 cs_pt_15 cs_pb_15">
              View Profile
            </Link>
          </div>
        </div>
      </div>
      <Spacing lg="120" md="50" />
    </>
  );
}